import React from 'react';
import TemplateHorizontalSquare from '../../Thumbnails/TemplateHorizontalSquare';
import TemplateVerticalRound from '../../Thumbnails/TemplateVerticalRound';
import TemplateVerticalSquare from '../../Thumbnails/TemplateVerticalSquare';
import { Icon, Text } from '../../uiold';
import { CardThumbnail, HoverFieldType } from '../types';
import HorizontalCardSquare from './HorizontalCardSquare';
import VerticalCardRound from './VerticalCardRound';
import VerticalCardSquare from './VerticalCardSquare';

export const CardThumbnails: Array<CardThumbnail> = [
  {
    type: 'horizontalCardSquare',
    title: t('Horizontal Card Square'),
    renderImage: () => <TemplateHorizontalSquare />,
  },
  {
    type: 'verticalCardSquare',
    title: t('Vertical Card Square'),
    renderImage: () => <TemplateVerticalSquare />,
  },
  {
    type: 'verticalCardRound',
    title: t('Vertical Card Round'),
    renderImage: () => <TemplateVerticalRound />,
  },
  {
    type: 'noTemplate',
    title: t('No Template'),
    renderImage: () => (
      <Icon name="xCircle" size="L" color="#0A2841" style={{ opacity: 0.2 }} />
    ),
  },
];

export default function getCardTemplates(params: {
  imageUrl: string;
  name: string;
  description: string;
  hoverFieldType?: HoverFieldType | null;
  nameColor: string;
  descriptionColor: string;
  backgroundColor: string;
}) {
  return {
    horizontalCardSquare: {
      component: <HorizontalCardSquare {...params} />,
    },
    verticalCardSquare: {
      component: <VerticalCardSquare {...params} />,
    },
    verticalCardRound: {
      component: <VerticalCardRound {...params} />,
    },
    noTemplate: {
      component: <Text>{t('No Vendor Profile Template')}</Text>,
    },
  };
}
